import { get, uniq } from 'lodash';

import { FIELD_PATHS, ASSET_TYPE } from '@funnels/constants';
import { Asset, StoreApplicant } from '@funnels/types';

export default function getApplicantAddresses(applicant: StoreApplicant, assets: Asset[]) {
  const currentAddress = get(
    { applicants: [applicant] },
    FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL_FORMATTED(0)
  );
  const mailingAddress = get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_MAILING_ADDRESS_FORMATTED(0));
  const assetAddress = assets
    .filter((asset) => get({ assets: [asset] }, FIELD_PATHS.ASSET_TYPE(0)) === ASSET_TYPE.PROPERTY)
    .map((asset) => get({ assets: [asset] }, FIELD_PATHS.ASSET_FORMATTED_ADDRESS(0)));

  return uniq([currentAddress, mailingAddress, ...assetAddress].filter((address) => address));
}
